import React from 'react';
import { Plugins } from '@leverege/plugin';
import SolidGraphBackground from "./background/SolidGraphBackground.js";
export const GraphFactory = Plugins.createFactory('Graph', {
  pluginKey: 'graph',
  strategy: Plugins.reactStrategy(React)
});
export const SeriesRendererFactory = Plugins.createFactory('SeriesRenderer', {
  pluginKey: 'renderer',
  name: 'factory.SeriesRenderer',
  strategy: Plugins.reactStrategy(React)
});
export const SeriesRendererContainerFactory = Plugins.createFactory('SeriesRenderer', {
  pluginKey: 'container',
  name: 'factory.SeriesContainer',
  strategy: Plugins.reactStrategy(React),
  defaultObject: React.Fragment
});
export const GlyphRendererFactory = Plugins.createFactory('GlyphRenderer', {
  pluginKey: 'renderer',
  name: 'factory.GlyphRenderer',
  strategy: Plugins.reactStrategy(React)
});
export const GraphBackgroundFactory = Plugins.createFactory('GraphBackgroundRenderer', {
  pluginKey: 'renderer',
  name: 'factory.GraphBackgroundRenderer',
  strategy: Plugins.reactStrategy(React),
  defaultObject: SolidGraphBackground
});